export default __webpack_public_path__ + "static/media/doc-icon.9c70c5c0.png";